/**
 * API-контракты для системы авторизации.
 *
 * Этот файл описывает Zod-схемы для auth-эндпоинтов.
 * При реализации — перенести в packages/shared/src/contracts/auth.ts
 */
import { z } from "zod";
// ─── Enums ───────────────────────────────────────────────────────────────────
export const UserRoleEnum = z.enum(["admin", "user"]);
export const UserStatusEnum = z.enum(["active", "deactivated"]);
// ─── Login ───────────────────────────────────────────────────────────────────
/** POST /api/auth/login — request */
export const LoginRequestSchema = z.object({
    login: z.string().min(1),
    password: z.string().min(1),
});
/** POST /api/auth/login — response 200 */
export const LoginResponseSchema = z.object({
    user: z.object({
        id: z.number(),
        login: z.string(),
        displayName: z.string(),
        role: UserRoleEnum,
    }),
    mustChangePassword: z.boolean(),
});
/** POST /api/auth/login — response 401 */
export const LoginErrorSchema = z.object({
    error: z.literal("INVALID_CREDENTIALS"),
    message: z.string(),
});
/** POST /api/auth/login — response 423 (аккаунт заблокирован) */
export const AccountLockedErrorSchema = z.object({
    error: z.literal("ACCOUNT_LOCKED"),
    message: z.string(),
    lockedUntil: z.string().datetime(),
});
// ─── Logout ──────────────────────────────────────────────────────────────────
/** POST /api/auth/logout — response 200 */
export const LogoutResponseSchema = z.object({
    success: z.literal(true),
});
// ─── Current User (session check) ────────────────────────────────────────────
/** GET /api/auth/me — response 200 */
export const MeResponseSchema = z.object({
    user: z.object({
        id: z.number(),
        login: z.string(),
        displayName: z.string(),
        role: UserRoleEnum,
    }),
    mustChangePassword: z.boolean(),
});
// ─── Change Password (forced + voluntary) ────────────────────────────────────
/** POST /api/auth/change-password — request */
export const ChangePasswordRequestSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(8),
});
/** POST /api/auth/change-password — response 200 */
export const ChangePasswordResponseSchema = z.object({
    success: z.literal(true),
});
//# sourceMappingURL=auth.js.map